import { render } from "./CloseIcon.vue.js?vue&type=template&id=b0a049f8!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./CloseIcon.vue?vue&type=template&id=b0a049f8"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__